import { useMemo } from "react";
import { AlertNotification, AlertValueType } from "@shared/models";

export const useGetDifferenceAlertTextShort = (item: AlertNotification, isComparison = true) => {
  const differenceText = useMemo(() => {
    const difference = Math.abs(Number(item.stable_value) - Number(item.value));
    const percentageDifference = (difference / Number(item.stable_value)) * 100;
    const absoluteDifference = Math.abs(Number(item.stable_value) - Number(item.value));
    const value = item.value_type === AlertValueType.ABSOLUTE ? absoluteDifference : percentageDifference;
    if (!isComparison) {
      return value;
    }

    const comparison = item.comparison_type.charAt(0).toUpperCase() + item.comparison_type.slice(1);

    return `${value.toFixed(2)} % ${comparison}`;
  }, [item, isComparison]);

  return differenceText;
};

const useGetDifferenceAlertText = (item: AlertNotification) => {
  const shortText = useGetDifferenceAlertTextShort(item);
  const differenceText = useMemo(() => {
    return shortText ? `${shortText} stable period` : "";
  }, [shortText]);

  return differenceText;
};

export default useGetDifferenceAlertText;
